import {
  type CheckoutConfig,
  allowedCheckoutConfigSubmitButtonText,
} from "@highnoteplatform/types";

const allowedEnvironments = ["test", "live"];

export const validateInputs = (config: CheckoutConfig) => {
  const errors: { message: string; field: string }[] = [];

  if (!config.clientToken || typeof config.clientToken !== "string") {
    errors.push({
      message: "clientToken is required and must be a string",
      field: "clientToken",
    });
  }

  if (!config.selector || typeof config.selector !== "string") {
    errors.push({
      message: "selector is required and must be a string",
      field: "selector",
    });
  }

  if (!config.onTokenizeError || typeof config.onTokenizeError !== "function") {
    errors.push({
      message: "onTokenizeError is required and must be a function",
      field: "onTokenizeError",
    });
  }

  if (
    !config.onTokenizeSuccess ||
    typeof config.onTokenizeSuccess !== "function"
  ) {
    errors.push({
      message: "onTokenizeSuccess is required and must be a function",
      field: "onTokenizeSuccess",
    });
  }

  if (config.environment && !allowedEnvironments.includes(config.environment)) {
    errors.push({
      message: `environment must be one of ${allowedEnvironments.join(", ")}`,
      field: "environment",
    });
  }

  if (
    config.submitButton?.text &&
    !allowedCheckoutConfigSubmitButtonText.includes(config.submitButton.text)
  ) {
    errors.push({
      message: `submitButton.text must be one of: ${allowedCheckoutConfigSubmitButtonText.join(
        ", "
      )}`,

      field: "submitButton.text",
    });
  }

  if (errors.length > 0) {
    return errors;
  }

  return undefined;
};
